import * as yup from 'yup'

/** Схема формы ввода имени пользователя (при регистрации). */
export const nameSchema = yup.object({
  name: yup
    .string()
    .trim()
    .min(1, 'Enter your name')
    .max(128, '128 characters max')
    .required('Enter your name')
})

export type NameFormValues = yup.InferType<typeof nameSchema>
